export const defaultRoutes = [
  {
    path: '/:guideId',
    name: 'author-page',
    component: () => import('@/pages/Author.vue'),
  },
];
